<template>
  <znl-dialog
    class="c-wxPayDialog"
    :visible="visible"
    :append-to-body="true"
    width="300px"
    :height="300"
    title="微信支付"
    :is-footer-show="false"
    @close="$emit('update:visible', false)"
  >
    <div
      class="p-AccurateDelivery-recharge-dialog"
      v-loading="loading"
      element-loading-text="请稍后..."
      v-if="!isPayComplete"
    >
      <div class="p-AccurateDelivery-QRCode">
        <img
          v-if="imgSrc"
          :src="imgSrc"
          alt="支付二维码"
          :width="148"
          :height="148"
          @click.stop="
            () => {
              getPushWxPayQrCode();
            }
          "
        />
        <div v-else class="past-due">二维码已过期，请重新打开</div>
      </div>
      <div class="p-AccurateDelivery-QRCode-money">
        <span class="money-span">{{ payInfo.Amount }}</span
        >元
      </div>
      <div class="footer">请使用微信扫码完成支付</div>
    </div>

    <div class="p-AccurateDelivery-paySuccess" v-if="isPayComplete">
      <div>
        <i class="iconfont icon-upload_completed_ic"></i>
      </div>
      支付成功
    </div>
  </znl-dialog>
</template>
<script>
import { httpPost, httpGet } from '../../assets/scripts/http';
import QRCode from 'qrcode';
export default {
  name: 'WxPayDialog',
  props: {
    visible: Boolean,
    order: {
      type: Object,
      default() {
        return {};
      }
    },
    onBindData: Function
  },
  data() {
    return {
      payInfo: {},
      loading: false,
      imgSrc: '',
      orderNo: '',
      payInfo: {
        Amount: 0
      },
      startTime: '',
      timeId: null,
      endTime: '',
      isPayComplete: false
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.getPushWxPayQrCode();
      } else {
        clearInterval(this.timeId);
        this.$nextTick(() => {
          this.imgSrc = '';
        });
      }
    }
  },
  methods: {
    // 获取支付二维码
    getPushWxPayQrCode() {
      if (!this.imgSrc) {
        this.loading = true;
      }
      httpPost('bomorder/getorderwxpayqrcode', {
        Amount: this.order.Amount,
        OrderGuid: this.order.OrderGuid
      })
        .then(data => {
          this.loading = false;
          if (data.Code === 0) {
            QRCode.toDataURL(data.Data.url).then(url => {
              this.imgSrc = url;
              this.orderNo = data.Data.orderNo;
              this.payInfo.Amount = data.Data.Amount;
              this.queryorderwxpayresult();
            });
          } else {
            this.$erroMess(data.Message);
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    // 查询是否成功
    queryorderwxpayresult() {
      const vm = this;
      this.startTime = new Date().getTime();
      this.timeId = setInterval(() => {
        this.endTime = new Date().getTime();
        // 充值码有效期20分钟
        if (this.endTime - this.startTime > 1000 * 60 * 20) {
          clearInterval(this.timeId);
          this.imgSrc = '';
        }
        // 查询充值结果
        httpGet(`bomorder/queryorderwxpayresult?billNo=${this.orderNo}`).then(
          res => {
            if (res.Code === 0) {
              this.isPayComplete = true;
              // 充值成功2秒后关闭窗口
              setTimeout(() => {
                vm.$emit('update:visible', false);
                if (vm.onBindData) {
                  vm.onBindData();
                }
              }, 2000);
            } else {
              this.isPayComplete = false;
            }
          }
        );
      }, 3000);
    }
  }
};
</script>
<style lang="scss">
.c-wxPayDialog {
  // text-align: center;
  .p-AccurateDelivery-recharge-dialog {
    padding-bottom: 10px;
    text-align: center;
  }
  .p-AccurateDelivery-QRCode {
    height: 15px;
    height: 150px;
    .past-due {
      height: 100%;
      line-height: 120px;
      font-weight: 900;
    }
  }
  .p-AccurateDelivery-QRCode-money {
    text-align: center;
    font-size: 16px;
    .money-span {
      color: #ee7700;
      font-weight: 600;
    }
  }
  .p-AccurateDelivery-paySuccess {
    line-height: 30px;
    font-size: 20px;
    color: #333;
    font-weight: 900;
    padding: 50px 0;
    text-align: center;
    .iconfont {
      color: #50a228;
      font-size: 80px;
      margin-right: 10px;
    }
  }
}
</style>
